import LEPRECH_EXT_1 from "./LEPRECH_EXT_1";

export default {
  LEPRECH_EXT_1,
};
